import { MasterSet } from '@api/pint/pint';
import { MasterData } from '@lib/content';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  LinearProgress,
  Box,
  Chip,
  Grid,
} from '@material-ui/core';

interface Badge {
  id: number;
  name: string;
  range: string;
}

interface Props {
  loading: boolean;
  badges: any;
}
export const badgeStyleMap: Record<string, { bg: string; color: string }> = {
  A: { bg: '#ECEFF1', color: '#455A64' },
  AA: { bg: '#E3F2FD', color: '#1E88E5' },
  AAA: { bg: '#E8F5E9', color: '#2E7D32' },
  'AAA+': { bg: '#FFF3E0', color: '#EF6C00' },
};

export const GeneralBadgeScoring: React.FC<Props> = ({ loading, badges }) => {
  if (loading) {
  return <Box p={3}>Loading badges…</Box>;
}
 
  const badgePriority: Record<string, number> = {
    'AAA+': 4,
    AAA: 3,
    AA: 2,
    A: 1,
  };
  const MAX_SCORE = 6.7;

  const getRangeValues = (range: string) => {
    const [min, max] = range.split('TO').map(v => Number(v.trim()));
    const progressValue = (max / MAX_SCORE) * 100;

    return progressValue;
  };
 const safeBadges = Array.isArray(badges) ? badges : [];

const sortedBadges = [...safeBadges].sort(
  (a, b) => badgePriority[b.name] - badgePriority[a.name]
);

if (!Array.isArray(badges) || badges.length === 0) {
  return <Box p={3}>No badge data available</Box>;
}

  return (
    <>
      <Box mb={2} textAlign={'center'}>
        <Typography variant="h6">Badge Scoring Levels</Typography>
        <Typography variant="body2" color="textSecondary">
          Defines reputation score ranges mapped to badge tiers
        </Typography>
      </Box>
      {/*  <Box display="flex" justifyContent="center">
        <Box width="100%" maxWidth={900}>
          <TableContainer component={Paper} elevation={3} style={{ borderRadius: 12 }}>
            <Table size="small" >
              <TableHead>
                <TableRow style={{ backgroundColor: '#f5f7fa', height: 64 }}>
                  <TableCell style={{ fontSize: 30,paddingLeft: 32 }}>
                    <b>Badge</b>
                  </TableCell>
                  <TableCell style={{ fontSize: 30 }}>
                    <b>Score Range</b>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {sortedBadges.map(badge => (
                  <TableRow key={badge.id} hover style={{ cursor: 'pointer' }}>
                    <TableCell style={{ fontSize: 30 ,paddingLeft: 32,verticalAlign: 'middle'}}>
                      <Chip
                        label={badge.name}
                        size="small"
                        style={{
                          backgroundColor: badgeStyleMap[badge.name]?.bg,
                          color: badgeStyleMap[badge.name]?.color,
                          fontWeight: 600,
                        }}
                      />
                    </TableCell>

                    <TableCell style={{ fontSize: 30 }}>
                      <Box display="flex" alignItems="center" style={{ gap: 20 }}>
                        <Typography variant="body1" style={{ fontSize: 15 }}>
                          {badge.range.replace('TO', ' – ')}
                        </Typography>

                        <LinearProgress
                          variant="determinate"
                          value={(badge.id / badges.length) * 100}
                          style={{
                            width: 120,
                            height: 6,
                            borderRadius: 4,
                          }}
                        />
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box> */}
      <Grid container spacing={3} justify="center">
        {sortedBadges.map(badge => {
          const style = badgeStyleMap[badge.name];

          return (
            <Grid item xs={12} sm={6} md={3} key={badge.id}>
              <Paper
                elevation={4}
                style={{
                  borderRadius: 16,
                  padding: 20,
                  textAlign: 'center',
                }}>
                <Chip
                  label={badge.name}
                  size="medium"
                  style={{
                    backgroundColor: style.bg,
                    color: style.color,
                    fontWeight: 700,
                    fontSize: 24,
                  }}
                />

                <Typography variant="h6" style={{ marginTop: 12 }}>
                  Score Range
                </Typography>

                <Typography variant="body1" style={{ marginTop: 4 }}>
                  {badge.range.replace('TO', ' – ')}
                </Typography>

                <LinearProgress
                  variant="determinate"
                  value={getRangeValues(badge.range)}
                  style={{
                    marginTop: 16,
                    height: 8,
                    borderRadius: 8,
                  }}
                />

                <Box display="flex" justifyContent="space-between">
                  <Typography variant="caption">0</Typography>
                  <Typography variant="caption">{MAX_SCORE}</Typography>
                </Box>
              </Paper>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};
